/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-05 15:48:31                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-05 16:00:30                               *
 *****************************************************************************/

/* SUMMARY
  * Styles
  * AdminTopNav: Admin top navigation bar
*/

/* Styles */
import { useLocation, useNavigate } from "react-router-dom";
import RealmSelector from "../../../../components/realm/RealmSelector";
import { api } from "../../../../services/api/api";
import logo from "../../../../logo.svg";
import "./AdminTopNav.scss";
import { useEffect, useState } from "react";
import { Button } from "@material-tailwind/react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { t } from "i18next";
/***/

/**
* AdminTopNav: Admin top navigation bar 
*/
export default function AdminTopNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  let handler: NodeJS.Timeout | null = null;
  
  const reload = () => {
    api.initToken();
    navigate({
      pathname: "/admin"
    }, { replace: true });

    handler = setTimeout(() => {
      navigate({
        pathname: location.pathname
      }, { replace: true });
    }, 10);    
  };

  const handleSync = async () => {
    if (isLoading) return;
    
    setIsLoading(true);
    try {
      await api.get("admin/users/reload");
      await new Promise((resolve) => setTimeout(resolve, 3000));
    } catch (error) {
      console.error("Error during synchronization:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handler && clearTimeout(handler);
  }, [handler]);

  return (
    <nav className="admin-topnav">
      <div className="logo-container">
        <img src={logo} alt={t("admin:topnav:logoAlt")} className="logo"/>
      </div>

      <div className="mr-2 flex items-center gap-2">
        <Button 
          onClick={handleSync}
          disabled={isLoading}
          color="blue"
          className="flex items-center gap-3"
        >
          {isLoading ? (
            <>
              <span>{t("admin:topnav:syncing")}</span>
            </>
          ) : (
            <>
              <ArrowPathIcon className="w-5 h-5" />
              {t("admin:topnav:sync")}
            </>
          )}
        </Button>
        <RealmSelector onChange={reload} />
      </div>
    </nav>
  );
}
/***/
